import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIService, ModelCreatePresignedURLInput } from '../API.service';
import { log } from 'console';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  files: string[] = [];
  fileUrl: string = '';
  hasError: boolean = false;
  loading: boolean = false;
  constructor(
    private snackBar: MatSnackBar,
    private apiService: APIService,
    private http: HttpClient
  ) {}

  UploadFile(data: any): Promise<any> {
    let targetUrl = 'https://file-upload-service.companyinclouds.com/';
    const headers = { 'content-type': 'application/json' };
    return this.http.post(targetUrl, data, { headers: headers }).toPromise();
  }

  GetZip(data: any) {
    let targetUrl = 'https://api.companyinclouds.com/excel';
    const headers = { 'content-type': 'application/json' };
    const options = {
      'access-control-allow-origin': '*',
      'access-control-allow-credentials': 'true',
      'Access-Control-Allow-Methods': 'POST',
      'content-type': 'application/json',
      responseType: 'text',
    };
    return this.http
      .post(targetUrl, data, { responseType: 'arraybuffer' })
      .toPromise();
  }

  async uploadImage(file: any): Promise<any> {
    let body = {
      profile: 'userData',
      content: file.replace(/^data:(.*,)?/, ''),
      reference: 'reference(optional)',
    };
    const res = await this.UploadFile(body);
    return res;
  }
  async uploadInvoices(file: any): Promise<any> {
    let body = {
      URL: file,
      excelsheet: true,
      multiple_files: false,
    };
    const res = await this.GetZip(body);
    return res;
  }

  async getPresignedUrl(file: any): Promise<string> {
    this.hasError = false;
    let name = file.name.toLowerCase();
    let data: ModelCreatePresignedURLInput = {
      originalFileName: name,
      profile: 'invoices',
      action: 'upload',
    };

    try {
      const response: any = await this.apiService.CreatePresignedURL(data);
      let presignData = {
        preSignedUrl: response.url,
        fileName: name,
        mimeType: response.mimeType
      };
      let shortenUrl = response.url.split('?')[0];
      const extension = shortenUrl.substring(shortenUrl.lastIndexOf('.') + 1).toLowerCase(); // Extract the extension from the file name

      await this.uploadImage2(file, presignData, extension);
      return shortenUrl;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async uploadFile(url: string, file: any): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');

    // Return the Promise here
    return new Promise<void>((resolve, reject) => {
      this.http.put(url, file.rawFile, { headers: headers }).subscribe(
        (response) => {
          console.log('File upload successful!', response);
          resolve();
        },
        (error) => {
          console.error('File upload error:', error);
          reject(error);
        }
      );
    });
  }

  async uploadImage2(
    selectedFile: File,
    presignData: { preSignedUrl: string; fileName: string; mimeType: string},
    extension: string
  ): Promise<void> {
    const blob = selectedFile.slice(0, selectedFile.size, `image/${extension}`);
    const editedFile = new File([blob], presignData.fileName, {
      type: presignData.mimeType,
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': presignData.mimeType,
      }),
    };
    return new Promise<void>((resolve, reject) => {
      this.http
        .put<any>(presignData.preSignedUrl, editedFile, httpOptions)
        .subscribe(
          (response) => {
            console.log('File upload successful!', response);
            resolve();
          },
          (error) => {
            console.error('File upload error:', error);
            reject(error);
          }
        );
    });
  }
  // new uplaod service end
}
